import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@Component({
  selector: 'ui-loading-modal',
  imports: [NzSpinModule],
  templateUrl: './loading-modal.html',
  styleUrl: './loading-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiLoadingModalComponent {
  title?: string;
  description?: string;

  get resolvedTitle(): string {
    return this.title?.trim() || 'Carregando...';
  }

  get resolvedDescription(): string {
    return this.description?.trim() || 'Isso pode demorar alguns segundos';
  }
}
